import React, { memo } from 'react';
import { Box, List, ListItem } from '@mui/material';

const ExplanationMutation = (props) => {

  const { lowercaseMutations, mutationType } = props;

  return (
    <div className={'sentences-and-letters'}>
      <Box className={'explanation-letters-sticky'}>
        <List className={`explanation-letters`}>
          {Object.keys(lowercaseMutations).map(letter => (
            <ListItem key={letter} className={`mutation-bg ${mutationType}`}>
              <em>{letter} → </em> {lowercaseMutations[ letter ]}
            </ListItem>
          ))}
        </List>
      </Box>
      <Box
        className={'explanation-children'}
        sx={{
          margin: '1rem 8rem 2rem 1rem',
        }}>
        {props.children}
      </Box>
    </div>
  );
};

export default memo(ExplanationMutation);
